var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    "+_vm._s(_vm.users.title)+"\n  "),_c('ul',_vm._l((_vm.users.products),function(product,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(product.model))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }